import api from '@/configs/GlobalRequestHandler.js';

export default {
  getWalletBalance: () => {
    return api.getRequest('/wallet');
  },
  getWalletHistory: (page = 1, search = '', per_page = 10) => {
    return api.getRequest(`/wallet/history?page=${page}&per_page=${per_page}&search=${search}`);
  },
  requestWithdrawal: (body) => {
    return api.postRequestWithBody('/wallet/withdraw', body);
  },
  getWithdrawals: (page = 1, per_page = 5) => {
    return api.getRequest(`/wallet/withdrawals?page=${page}&per_page=${per_page}`);
  },
  getAdminWithdrawals: (params) => {
    return api.getRequest('/admin/withdrawals', { params });
  },
  updateWithdrawalStatus: (id, status, rejection_reason) => {
    return api.putRequestWithBody(`/admin/withdrawals/${id}/status`, { status, rejection_reason });
  }
}
